<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title"><a id="page_ix"></a>Contents</h1>
<p class="toc-fm"><a href="#/008_Introduction#fm-1">Introduction, by Thomas Sugrue</a></p>
<p class="toc-fm"><a href="#/009_Preface#fm-2">Preface, by Walter Kaufmann</a></p>
<p class="toc-chap"><a href="#/010_Chapter01#ch-1">  1. The Golden Mouth</a></p>
<p class="toc-chap"><span href="#/011_Chapter02#ch-2" title="Link target outside of Sample">  2. Thy Brother’s Blood</span></p>
<p class="toc-chap"><span href="#/012_Chapter03#ch-3" title="Link target outside of Sample">  3. Wanderers Upon the Earth</span></p>
<p class="toc-chap"><span href="#/013_Chapter04#ch-4" title="Link target outside of Sample">  4. The Badge of Shame</span></p>
<p class="toc-chap"><span href="#/014_Chapter05#ch-5" title="Link target outside of Sample">  5. The Murderous Lie</span></p>
<p class="toc-chap"><span href="#/015_Chapter06#ch-6" title="Link target outside of Sample">  6. “Money Was Their God”</span></p>
<p class="toc-chap"><span href="#/016_Chapter07#ch-7" title="Link target outside of Sample">  7. Godfathers of Belsen</span></p>
<p class="toc-chap"><span href="#/017_Chapter08#ch-8" title="Link target outside of Sample">  8. Workers of Iniquity</span></p>
<p class="toc-chap"><span href="#/018_Chapter09#ch-9" title="Link target outside of Sample">  9. The “Inevitable Failure”</span></p>
<p class="toc-chap"><span href="#/019_Chapter10#ch-10" title="Link target outside of Sample">10. Pride, Arrogance, and Hate</span></p>
<p class="toc-chap"><span href="#/020_Epilogue#ch-11" title="Link target outside of Sample">11. Epilogue</span></p>
<p class="toc-bm"><span href="#/021_Appendix#ch-12" title="Link target outside of Sample">Appendix</span></p>
<p class="toc-sec"><span href="#/021_Appendix#sec-1" title="Link target outside of Sample">A. “The Jews” in St. John’s Gospel</span></p>
<p class="toc-sec"><span href="#/021_Appendix#sec-2" title="Link target outside of Sample">B. The Ritual-Murder Charge in Modern Times</span></p>
<p class="toc-sec"><span href="#/021_Appendix#sec-3" title="Link target outside of Sample">C. Letter to Edouard Drumont</span></p>
<p class="toc-sec"><span href="#/021_Appendix#sec-4" title="Link target outside of Sample">D. Jewish Children and the Nazis</span></p>
<p class="toc-bm"><span href="#/022_Bibliography#bm-1" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc-bm"><span href="#/023_Endnotes#bm-2" title="Link target outside of Sample">Notes</span></p>
<p class="toc-bm">Index</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 007_Contents.vue?7cb2d3a9